module.exports = "/static/assets/e97cbeda206c8637879f8db5477d494f.png";